export default __webpack_public_path__ + "static/media/matti_m.64242f33.jpg";